import React from "react";

export default function GridItem({children}: any) {
    return (
        <div>{children}</div>
    )
}